<div class="icon-name" fxLayout="row" fxLayoutAlign="start center">
  <div>
    <shr-fa class="icon" [matTooltip]="registerBase?.typeDisplayName" [name]="registerBase?.typeFaIconName"></shr-fa>
  </div>
  <div>
    {{ registerBase?.registerName }}
  </div>
</div>